import { create } from 'zustand';

// Page-level UI state for the Emissions data page (modal + upload-guide
// flags + triggers). Hoisted out of EmissionsDataTable so the page header
// can fire "New emission" + "Bulk upload" from above the table without
// cross-cutting refs. The wizard + modal mounts still live inside the
// table where their submit handlers sit.
const useEmissionsPageStore = create((set) => ({
  // Edit / create emission factor modal.
  showEmissionsModal: false,
  isCreatingNewEmission: false,
  setShowEmissionsModal: (open) => set({ showEmissionsModal: open }),
  setIsCreatingNewEmission: (creating) => set({ isCreatingNewEmission: creating }),

  triggerNewEmission: () => set({ isCreatingNewEmission: true, showEmissionsModal: true }),

  // Bulk upload (Excel import) flow.
  isEmissionsImportOpen: false,
  setIsEmissionsImportOpen: (open) => set({ isEmissionsImportOpen: open }),

  showEmissionsUploadGuide: false,
  setShowEmissionsUploadGuide: (open) => set({ showEmissionsUploadGuide: open }),

  triggerUploadFlow: () => {
    let hasSkipped = false;
    try {
      hasSkipped = window.localStorage.getItem('emissions-upload-guide-skip') === 'always';
    } catch (_err) {
      // Ignore storage failures (private mode etc.).
    }
    if (hasSkipped) {
      set({ isEmissionsImportOpen: true });
    } else {
      set({ showEmissionsUploadGuide: true });
    }
  },

  // See suppliersStore.closeAllModals — same module-global lifetime problem,
  // same contract: navigation shuts every modal this store gates.
  closeAllModals: () =>
    set({
      showEmissionsModal: false,
      isCreatingNewEmission: false,
      isEmissionsImportOpen: false,
      showEmissionsUploadGuide: false,
    }),
}));

export default useEmissionsPageStore;
